export default __webpack_public_path__ + "static/media/token-placeholder.9281c822.svg";